import type { TenderRecord, OuterPayload } from '../../../types/analyticstypes';
import TenderCard from './TenderCard';

export default function PaymentTab({
  tenders,
  outer,
}: {
  tenders?: TenderRecord[];
  outer: OuterPayload;
}) {
  if (!tenders || tenders.length === 0) {
    return (
      <div className="text-sm text-gray-500 italic p-6 text-center bg-gray-50 rounded-lg">
        No payment captured for this transaction
        {outer.status === 'ABANDONED' ? ' — session ended before checkout.' : '.'}
      </div>
    );
  }

  return (
    <div className="space-y-3">
      <div className="text-xs text-gray-500">
        {tenders.length} payment attempt{tenders.length !== 1 ? 's' : ''}
        {outer.paid !== undefined && (
          <span className="ml-2">
            ·{' '}
            <span className={outer.paid ? 'text-green-700 font-medium' : 'text-amber-700'}>
              {outer.paid ? 'Settled' : 'Pending'}
            </span>
          </span>
        )}
        {outer.provider && <span className="ml-2">· via {outer.provider}</span>}
      </div>
      {tenders.map((t, i) => (
        <TenderCard key={t.providerTicketNum ?? i} tender={t} />
      ))}
    </div>
  );
}
